import {NotificationData, NotificationType, PortalNotification} from "../../src/typings/notifications";

class Notification implements PortalNotification {

    private _backing: kendo.ui.Notification | undefined
    private element: JQuery

    // Getter for the Kendo Notification widget
    get backing(): kendo.ui.Notification {
        // Run initialize again if still undefined, which is possible due to script loading sequences
        if (this._backing == undefined) {
            this.initialize()
        }
        return this._backing as kendo.ui.Notification;
    }

    constructor(element: JQuery) {
        this.element = element
        this.initialize()
    }

    initialize(): void {
        if (this._backing == undefined) {
            this._backing = <kendo.ui.Notification>$(this.element).data("kendoNotification")
        }
    }

    public error(message: string): void {
        const data: NotificationData = {message: message};
        this.backing.error(data)
    }

    public getNotifications(): JQuery {
        return this.backing.getNotifications()
    }

    public hide(): void {
        this.backing.hide()
    }

    public info(message: string): void {
        const data: NotificationData = {message: message};
        this.backing.info(data)
    }

    show(message: string, type: NotificationType): void {
        const data: NotificationData = {message: message};
        this.backing.show(data, type)
    }

    public showText(message: string, type: NotificationType): void {
        const data: NotificationData = {message: message};
        this.backing.showText(data, type)
    }

    public success(message: string): void {
        const data: NotificationData = {message: message};
        this.backing.success(data)
    }

    public warning(message: string): void {
        const data: NotificationData = {message: message};
        this.backing.warning(data)
    }
}

// Element id "popupNotification" must match the widget name declared in the corresponding view
window.notification = new Notification($("#popupNotification"));
